<template>
  <button class="jps-text-button ui-edit-layout-button" :class="buttonClass" :disabled="disabled">
    <BaseIcon :name="getIconName()" :is-spin="isSaving" size="size-6" />
    <span class="el-label">{{ ls(getLabel()) }}</span>
  </button>
</template>

<script lang="ts" setup>
import type { SVG_NAMES } from '~/components/icons'
const { ls } = useI18n()

interface Props {
  type: 'NEW_NOTE' | 'NEW_GALLERY' | 'NEW_SEARCH' | 'PREVIEW' | 'IMPORT' | 'EXPORT'
      | 'COPY' | 'DELETE' | 'UNDO' | 'REDO' | 'SAVE' | 'FINISH' | 'EDIT'
  disabled?: boolean
  buttonClass?: string[]
  isSaving? : boolean
}
const props = withDefaults(defineProps<Props>(), {
  disabled: false,
  buttonClass: () => [],
  isSaving: false,
})

const getIconName = (): SVG_NAMES => {
  switch (props.type) {
    case 'NEW_NOTE': return 'mdi/plus-box-outline'
    case 'NEW_GALLERY': return 'mdi/plus-box-outline'
    case 'NEW_SEARCH': return 'mdi/plus-box-outline'
    case 'PREVIEW': return 'mdi/eye'
    case 'IMPORT': return 'mdi/import'
    case 'EXPORT': return 'mdi/export'
    case 'COPY': return 'mdi/content-duplicate'
    case 'DELETE': return 'mdi/delete-forever-outline'
    case 'UNDO': return 'mdi/undo'
    case 'REDO': return 'mdi/redo'
    case 'SAVE': return props.isSaving ? 'mdi/sync' : 'mdi/content-save'
    case 'FINISH': return 'mdi/check'
    case 'EDIT': return 'mdi/pencil'
  }
}
const getLabel = (): LangString => {
  switch (props.type) {
    case 'NEW_NOTE': return { ja: '新しいノート', en: 'New note' }
    case 'NEW_GALLERY': return { ja: '新しいギャラリー', en: 'New gallery' }
    case 'NEW_SEARCH': return { ja: '新しいサーチ', en: 'New customized search' }
    case 'PREVIEW': return { ja: 'プレビュー', en: 'Preview' }
    case 'IMPORT': return { ja: 'インポート', en: 'Import' }
    case 'EXPORT': return { ja: 'エクスポート', en: 'Export' }
    case 'COPY': return { ja: '複製', en: 'Duplicate' }
    case 'DELETE': return { ja: '削除', en: 'Delete' }
    case 'UNDO': return { ja: '元に戻す', en: 'Undo' }
    case 'REDO': return { ja: 'やり直し', en: 'Redo' }
    case 'SAVE': return { ja: '保存', en: 'Save' }
    case 'FINISH': return { ja: '完了', en: 'Finish' }
    case 'EDIT': return { ja: '編集', en: 'Edit' }
  }
}
</script>

<style lang="scss" scoped>
</style>
